import { FunctionComponent } from "react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { LEAD_ROTATION_COLUMNS } from "../../Values/tables";
import {fetchRotation,deleteLeadRotation} from "../../Services/contacts";
import TopBar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import Loading from "../../Components/Loading/Loading";
import CustomTable from "../../Components/CustomTable/CustomTable";
import styles from './LeadDistributor.module.css';
import {themeColors} from "../../Components/theme";
import { useMediaQuery } from "@material-ui/core";

type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any;
  teamLeadUsers: any;
  theme: any;
};

/**
 * ReassignList Component
 * ----------------------
 * Displays the list of Lead Rotation Logic rules. 
 * Allows users to:
 *    - View rotation logic records
 *    - Delete a rotation entry
 *    - Search and filter the list
 *    - Use custom table column settings
 */
const ReassignList: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  theme
}) => {
   // Responsive behavior for mobile view
  const isMobile = useMediaQuery('(max-width: 900px)');

  // Redux dispatcher
  const dispatcher = useDispatch();

  // Table Data
  const [filterData, setFilterData] = useState<any[]>([]);

  // Table selection state
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);

   // Search / Column Customization
  const [searchedItem, setsearchedItem] = useState("");
  const [columnModal, setColumnModal] = useState(false);

  // Trigger to clear table filters
  const [clearFilterTable, setClearFilterTable] = useState(false);


  /**
   * Fetch Rotation Logic List
   * --------------------------
   * Fetches rotation logic entries from Firestore based on org ID.
   * Updates filterData state with the retrieved list.
   */
  useEffect(() => {
    if (user.organization_id) {
      const unsub = fetchRotation(user.organization_id, (data) =>
        setFilterData(data)
      );
      return () => {
        unsub();
      };
    }
  }, [user]);
  
  /**
   * Delete Rotation Logic Handler
   * -----------------------------
   * Removes an entry from list & updates Firestore.
   */
  const handleDeleteLeadDistributor=(data:any,index:any)=>{
    if (window.confirm('Are you sure you want to delete this Lead Rotation Logic?')) {
      if (index !== undefined) {
        const newList = [...filterData];
        newList.splice(index, 1);
        setFilterData(newList);
        deleteLeadRotation(
          user.organization_id,
          newList,
          dispatcher,
        );
      }
    }
  }

   /**
   * Clear filter handler for the CustomTable component.
   */
  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };

  // Theme-based background and text styling
  const containerStyles = {
    backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
  };


  /**
   * Render Component UI
   */
  return (
    <>
     <div className={styles.parent} style={{ display: "block",marginTop:isMobile?"6%":"4%",...containerStyles }}>
     {filterData === undefined && <Loading />}
      <div className={styles.topBar} style={{ marginTop: "0px",...containerStyles }}>
        <TopBar
          history={history}
          title={"Lead Distribution"}
          path={"/addContacts"}
          onChange={(val) => setsearchedItem(val)}
          filterText={"Status"}
          setColumnModal={(data) => setColumnModal(data)}
          show={false}
          showStatusBox={false}
          clearFilter={handleClearFilter}
        />
      </div>
      <div className={commonStyle.parentp} style={{minHeight:"450px",...containerStyles}}>
        <CustomTable
          tableColumns={LEAD_ROTATION_COLUMNS}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="LeadRotation"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setSearchedItem={(val) => setsearchedItem(val)}
          handleDeleteLeadRotation={handleDeleteLeadDistributor}
          clearFilterTable={clearFilterTable}
        />
      </div>
      </div>
    </>
  );
};

/**
 * Map Redux State to Props
 */
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(ReassignList);
